/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BudgetVersionDto } from '../../models/budget-version-dto';

export interface GetBudgetVersion$Params {
  id: string;
}

export function getBudgetVersion(http: HttpClient, rootUrl: string, params: GetBudgetVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<BudgetVersionDto>> {
  const rb = new RequestBuilder(rootUrl, getBudgetVersion.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BudgetVersionDto>;
    })
  );
}

getBudgetVersion.PATH = '/v0/budget-versions/{id}';
